import './calculator.component.scss'

const elems = document.querySelectorAll('.calculator-body__wrap-input')

const cardProcessingNumber = document.getElementById('card-processing-number')
const monthlySalesNumber = document.getElementById('monthly-sales-number')

const total = document.querySelector('.calculator-body__total')


function calc() {
	if (total) {
		const totalScore = (cardProcessingNumber.value / monthlySalesNumber.value) * 100
		total.textContent = `${new Intl.NumberFormat('en-US').format(+totalScore.toFixed(2))}%`
	}
}
calc()

function recalc(_this) {
	if (_this.value > Number(_this.max)) {
		_this.value = _this.max
	}
	if (_this.value < Number(_this.min)) {
		_this.value = _this.min
	}

	calc()
}


if (elems.length > 0) {
	elems.forEach(i => {
		const numericField = i.querySelector('input[type=number]')

		if (numericField) {
			numericField.addEventListener('change', function() {
				recalc(this)
			})
		}
	})
}
